import { useEffect, useRef, useState } from 'react';

import {
  CountryEntity,
  LegalClientOnboardingStatusType,
  OnboardingStatusType,
} from 'api/types/entity';
import {
  LocationCountryFilter,
  RegistrationCountryFilter,
  RiskLevelFilter,
  StatusFilter,
} from 'modules/client/common/components';

import { LegalClientsFilterTypes, RiskLevelFilterType } from '../../types';

interface Props {
  filter: LegalClientsFilterTypes;
  registrationCountries?: CountryEntity[];
  locationCountries?: CountryEntity[];
  onApply: (f: LegalClientsFilterTypes) => void;
}

export const LegalClientsFilters = ({
  filter,
  registrationCountries,
  locationCountries,
  onApply,
}: Props) => {
  const isMounted = useRef(false);

  const [statuses, setStatuses] = useState<OnboardingStatusType[]>(
    filter.statuses ?? []
  );

  const [riskLevels, setRiskLevels] = useState<RiskLevelFilterType[]>(
    filter.riskLevels ?? []
  );

  const [selectedRegistrationCountries, setSelectedRegistrationCountries] =
    useState<string[]>(filter.registrationCountries ?? []);

  const [selectedLocationCountries, setSelectedLocationCountries] = useState<
    string[]
  >(filter.locationCountries ?? []);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }

    onApply({
      statuses: statuses.length
        ? (statuses as unknown as LegalClientOnboardingStatusType[])
        : undefined,
      riskLevels: riskLevels.length ? riskLevels : undefined,
      registrationCountries: selectedRegistrationCountries.length
        ? selectedRegistrationCountries
        : undefined,
      locationCountries: selectedLocationCountries.length
        ? selectedLocationCountries
        : undefined,
    });
  }, [
    onApply,
    riskLevels,
    selectedLocationCountries,
    selectedRegistrationCountries,
    statuses,
  ]);

  return (
    <>
      <StatusFilter setStatuses={setStatuses} statuses={statuses} />
      <RiskLevelFilter riskLevels={riskLevels} setRiskLevels={setRiskLevels} />
      <RegistrationCountryFilter
        countries={registrationCountries ?? []}
        selectedCountries={selectedRegistrationCountries}
        setSelectedCountries={setSelectedRegistrationCountries}
      />
      <LocationCountryFilter
        countries={locationCountries ?? []}
        selectedCountries={selectedLocationCountries}
        setSelectedCountries={setSelectedLocationCountries}
      />
    </>
  );
};
